import { Record } from "immutable";

const UserRecord = new Record({
  email: undefined,
  id: undefined,
  send_notifications: false,
  is_monetization: false,
  balance: 0,
  warn_balance: "",
  old_password: "",
  new_password1: "",
  new_password2: "",
  must_accept_offer: false,
  has_password: true,
  has_recipient: false
});

export default class User extends UserRecord {}
